import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    stepperContainer: {
        maxWidth: "1044px",
        margin: "10px auto",
        padding: theme.spacing(0, 3),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            padding: theme.spacing(0, 2),
        },
        "& span": {
            lineHeight: 1.2,
        },
        "& button": {
            fontSize: "1em",
            "&:hover": {
                textDecoration: "underline",
            },
        },
    },
    stepper: {
        maxWidth: "900px",
        margin: "auto",
    },
}));
